import ChooseAddressCard from './components/common/ChooseAddressCard';
import CheckoutItem from './components/common/CheckoutItem';

import AddAddressForm from './components/AddAddressForm';

import { uuidv4, formatPrice } from '../lib/utils'

import useTranslations from "../providers/useTranslations";
import { CartContext } from '../providers/CartContext';
import { BusinessContext } from '../providers/BusinessContext';

import DeliverTypeSelector from './order/deliver_type'
import LatLon from '../lib/latlon';
import { getFromApi, postToMapsApi } from '../lib/api'
import { round } from '../lib/utils'

import { addStyleLink, addScriptLink } from './utils'

import { prefixedColour, padZero, invertColor, bestStringValue, addStyleElement } from './utils'

const Checkout = (props) => {

  const { business, menu, doCheckout, setStage } = props

  const [addresses, setAddresses] = React.useState([])
  const [position, setPosition] = React.useState(null)
  const [showAddressModal, setShowAddressModal] = React.useState(false)

  const [paymentMethod, setPaymentMethod] = React.useState('')
  const [paymentMethods, setPaymentMethods] = React.useState([])
  const [methodData, SetMethodData] = React.useState(null)
  const [bankName, setBankName] = React.useState(null)
  const [deliveryChargeRange, setChargeRange] = React.useState(null)
  const [barrioCost, setBarrioCost] = React.useState(null)
  const [deliveryAgentId, setDeliveryAgentId] = React.useState(null)
  const [distanceCost, setDistanceCost] = React.useState(null)
  const [deliveryMessage, setDeliveryMessage] = React.useState(null)
  const [calculationMessages, setCalculationMessages] = React.useState([])
  const [packingCost, setPackingCost] = React.useState(null)
  const [deliveryAddress, setDeliveryAddress] = React.useState(null)
  const [deliverType, setDeliverType] = React.useState(null)
  const [minimumOrderValue, setMinimumOrderValue] = React.useState(0)
  const [minimumOrderMessage, setMinimumOrderMessage] = React.useState(null)
  const [fixedTable, setFixedTable] = React.useState(false)
  const [isOpen, setIsOpen] = React.useState(true)
  const [totalWithDelivery, setTotalWithDelivery] = React.useState(true)
  const [barrios, setBarrios] = React.useState([]);
  const [itiField, setItiField] = React.useState(null)

  // takeaway form data
  const [name, setName] = React.useState(null)
  const [phone, setPhone] = React.useState(null)
  const [email, setEmail] = React.useState(null)

  // table form data
  const [table, setTable] = React.useState(null)

  // Add new state for the custom modal
  const [showCustomModal, setShowCustomModal] = React.useState(false);
  const [customModalConfig, setCustomModalConfig] = React.useState({
    title: '',
    body: '',
    onConfirm: null,
    onClose: null
  });

  // Add new function to show modal
  const showModal = (title, body, onConfirm = null, onClose = null) => {
    setCustomModalConfig({
      title,
      body,
      onConfirm,
      onClose
    });
    setShowCustomModal(true);
  };

  // Add modal component using vanilla HTML/CSS
  const customModal = () => {
    if (!showCustomModal) return null;

    return (
      <div className="modal-overlay" onClick={(e) => {
        if (e.target.className === 'modal-overlay') {
          setShowCustomModal(false);
        }
      }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5>{customModalConfig.title}</h5>
            <button
              className="modal-close"
              onClick={() => setShowCustomModal(false)}
            >
              ×
            </button>
          </div>
          <div className="modal-body">
            {customModalConfig.body}
          </div>
          <div className="modal-footer">
            {customModalConfig.onClose &&
              <button
                className="btn btn-secondary"
                onClick={() => setShowCustomModal(false)}
              >
                {tr("Close")}
              </button>
            }
            {customModalConfig.onConfirm && (
              <button
                className="btn btn-primary"
                onClick={() => {
                  customModalConfig.onConfirm();
                  setShowCustomModal(false);
                }}
              >
                {tr("Confirm")}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Add useEffect to handle ESC key
  React.useEffect(() => {
    console.log("Checkout useEffect handleEsc")
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        setShowCustomModal(false);
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  // Add CSS styles for the modal
  React.useEffect(() => {
    console.log("Checkout useEffect add modal Style")
    const style = document.createElement('style');
    style.textContent = `
      .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
      }

      .modal-content {
        background: white;
        border-radius: 8px;
        width: 90%;
        max-width: 500px;
        position: relative;
        animation: modalFadeIn 0.3s;
      }

      @keyframes modalFadeIn {
        from { opacity: 0; transform: translateY(-20px); }
        to { opacity: 1; transform: translateY(0); }
      }

      .modal-header {
        padding: 1rem;
        border-bottom: 1px solid #dee2e6;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .modal-close {
        border: none;
        background: none;
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        margin: 0;
        line-height: 1;
      }

      .modal-body {
        padding: 1rem;
      }

      .modal-footer {
        padding: 1rem;
        border-top: 1px solid #dee2e6;
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
      }
    `;
    document.head.appendChild(style);

    let link = addStyleLink("/vendor/progress-bar.css")
    let js = addScriptLink("/vendor/progress-bar.js")

    return () => {
      document.head.removeChild(style);
      document.head.removeChild(link);
      document.head.removeChild(js);
    };
  }, []);


  React.useEffect(() => {
    const input = document.querySelector("#add-address-phone");

    console.log("input", input)

    if (input) {
      let iti = window.intlTelInput(input, {
        i18n: "es",
        initialCountry: "CO",
        autoPlaceholder: "off"
        //   //loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.1/build/js/utils.js"),
      });

      setItiField(iti)
    }

  }, [deliverType]);

  ///////

  const { cartItems, hasAlcohol, ageConfirmed, setAgeConfirmed, dateOfBirth, setDateOfBirth,
    setItemQuantity, removeItem, setPendingOrder, totalItemsCost, applyDiscount,
    isDiscountActive, discountMessage } = React.useContext(CartContext);

  const { checkMenuPeriods, configValue, selectedCity, selectedProvince, locationConfigValue,
    locationConfigNumber } = React.useContext(BusinessContext);

  const { tr,  /* , getTranslations, locale, translations, setLocale */ } = useTranslations();

  React.useEffect(() => {

    //console.log("checkout with", props)

    // ensure any previous order is removed
    localStorage.removeItem('pendingOrder')
    setPendingOrder(null)

    let tn = localStorage.getItem('tableNum')

    if (tn) {
      setTable(tn)
      setDeliverType('table')
      setFixedTable(true)
    }

    let list = localStorage.getItem('addressList')

    if (list) {
      //console.log("address list", list)
      let addresses = JSON.parse(list)
      setAddresses(addresses);

      if (addresses && addresses.length > 0) {
        let fa = addresses[0]
        setName(fa.name)
        setPhone(fa.phone)
        setEmail(fa.email)
      }
    }

    if (menu && business) {
      //console.log("show menu", business, menu)
      addStyleElement(business, menu)

      let cfgName = "deliveryPaymentOptions"

      if (deliverType === 'takeaway' || deliverType === "table" || table != null)
        cfgName = "takeawayPaymentOptions"

      //console.log("useEffect", deliverType, cfgName, menu)

      let md = locationConfigValue(business.Configs, menu.Location.id, cfgName, null)

      if (md) {
        //console.log("payment methods", deliverType, md)
        setPaymentMethods(md.split(","))
      }

      // get the delivery charge range from business configs
      /* eslint-disable react-hooks/exhaustive-deps */
      setChargeRange(locationConfigValue(business.Configs, menu.Location.id, "deliveryChargeRange", null))
      /* eslint-disable react-hooks/exhaustive-deps */
      setPackingCost(locationConfigNumber(business.Configs, menu.Location.id, "packingCost", null))

      setDeliveryAgentId(locationConfigNumber(business.Configs, menu.Location.id, "deliveryServiceAgentId", 0))

      /* eslint-disable react-hooks/exhaustive-deps */
      setMinimumOrderValue(locationConfigNumber(business.Configs, menu.Location.id, "minimumOrderValue", 0))
      /* eslint-disable react-hooks/exhaustive-deps */
      setMinimumOrderMessage(locationConfigValue(business.Configs, menu.Location.id, "minimumOrderMessage", null))
      /* eslint-disable react-hooks/exhaustive-deps */
      setTotalWithDelivery(locationConfigValue(business.Configs, menu.Location.id, "totalWithDelivery", "true") === "true")

      let banc = locationConfigValue(business.Configs, menu.Location.id, "bancolombia", null)

      if (banc) {
        setBankName('Bancolombia')
      } else {
        banc = locationConfigValue(business.Configs, menu.Location.id, "davivienda", null)
        if (banc) {
          setBankName('Davivienda')
        }
      }

      if (business && business.type == "Gastronomy") {

        let openPeriod = checkMenuPeriods(menu, business)

        if (openPeriod && openPeriod.isOpen) {
          setIsOpen(openPeriod.isOpen)
        } else {
          // if the merchant will open within 2 minutes allow the order
          if (openPeriod && openPeriod.openIn < 120) {
            setIsOpen(true)
          } else {
            setIsOpen(false)
          }
        }

        let ll = LatLon.fromString(menu.Location.latlng)

        // double check by calling the API endpont to check the menu periods
        let url = `/api/v1/menu/can_order/${menu.id}/${ll.lat}/${ll.lon}`
        getFromApi(url, {}, (result) => {
          //console.log("can_order", result.result)
          setIsOpen(result.result == true || result.result == "true")
        }, (error) => {
          console.log("Error getting can_order", error)
        })
      }

    } else {
      window.location.href = "/"
    }


  }, [deliverType]);

  //console.log("using", paymentMethods, minimumOrderValue, deliveryChargeRange, barrioCost)

  const iconForTitle = (title) => {
    switch (title) {
      case tr("Home"): return "home";
      case tr("Work"): return "briefcase";
      default: return 'building-alt'
    }
  }

  const confirmButton = () => {
    let phoneNumber = ''
    if (itiField) {
      phoneNumber = itiField.getNumber()
    }
    console.log("phoneNumber", phoneNumber)

    if (!isOpen) {
      return (
        <div className="btn btn-success btn-block btn-lg"
          onClick={() => {
            alert(tr("This business cannot take orders at the moment, please check back later"))
          }}

        >{tr("Confirm Order")} </div>
      )
    }

    if (!deliverType) {
      return (
        <div className="btn btn-success btn-block btn-lg"
          onClick={() => {
            alert(tr("Please select either delivery or takeaway"))
          }}

        >{tr("Confirm Order")} </div>
      )
    }

    if (deliverType === 'delivery') {
      /*
        if the minimumOrderValue > 0 and the orderValue is less than the minimum show an alert message
      */
      if (menu && minimumOrderValue > 0 && totalItemsCost(cartItems) < minimumOrderValue) {
        let message = minimumOrderMessage || tr("Order value is less than the minimum")
        return (
          <div className="btn btn-success btn-block btn-lg"
            onClick={() => {
              alert(message)
            }}

          >{tr("Confirm Order")} </div>
        )
      }
    }

    // check a delivery address is selected
    if (deliverType === 'delivery' && !deliveryAddress) {
      return (
        <div className="btn btn-success btn-block btn-lg"
          onClick={() => {
            alert(tr("Please select a delivery address"))
          }}

        >{tr("Confirm Order")} </div>
      )
    } else if ((deliverType === 'takeaway' || deliverType === 'table')) {

      if (!name || !phoneNumber) {
        console.log("name", name)
        console.log("tphone", phoneNumber)
        return (
          <div className="btn btn-success btn-block btn-lg"
            onClick={() => {
              alert(tr("Please enter your name and phone number"))
            }}

          >{tr("Confirm Order")} </div>
        )
      }
    } else if (deliverType === 'table' && !table) {
      return (
        <div className="btn btn-success btn-block btn-lg"
          onClick={() => {
            alert(tr("Please enter a valid table number"))
          }}

        >{tr("Confirm Order")} </div>
      )
    }

    // check a payment method is selected
    if (!paymentMethod) {
      return (
        <div className="btn btn-success btn-block btn-lg"
          onClick={() => {
            alert(tr("Please select a payment method"))
          }}

        >{tr("Confirm Order")} </div>
      )
    }

    // check there are no restricted products (in house consumption only)
    if (deliverType !== 'table') {
      let res = cartItems.find((item, index) => item.restricted)

      if (res) {
        return (
          <div className="btn btn-success btn-block btn-lg"
            onClick={() => {
              if (deliverType !== 'delivery') {
                alert(tr("There are restricted items in the cart that cannot be delivered"))
              } else {
                alert(tr("There are restricted items in the cart that cannot be taken away"))
              }
            }}

          >{tr("Confirm Order")} </div>
        )
      }
    }

    let discountedCost = null

    if (menu.discountType == "" || isDiscountActive(menu) == false) {
      // noop
    } else {
      let itemscost = totalItemsCost(cartItems)
      let newCost = applyDiscount(itemscost, menu)

      if (newCost != itemscost) {
        discountedCost = newCost
      }

      console.log("discountedCost", itemscost, newCost, discountedCost)
    }

    let da = deliveryAddress || {}

    // ensure delivery data has province and country
    da.province = menu.Location.province
    da.country = menu.Location.country
    da.barrioCost = barrioCost
    da.distanceCost = distanceCost

    let checkoutData = {
      selectedMenu: menu,
      items: cartItems,
      deliverType: deliverType,
      deliveryData: da,
      paymentMethod: paymentMethod,
      methodData: methodData,
      bankName: bankName,
      discountedCost: discountedCost
    }


    if (deliverType === 'takeaway') {
      checkoutData.deliveryData = {
        name: name,
        phone: phoneNumber,
        email: email,
        city: menu.Location.city,
        province: menu.Location.province,
        country: menu.Location.country
      }
    } else if (deliverType === "table") {
      checkoutData.deliveryData = {
        name: name,
        phone: phoneNumber,
        tableNum: table,
        destination: `${tr("Table")} ${table}`,
        city: menu.Location.city,
        province: menu.Location.province,
        country: menu.Location.country
      }
    }

    console.log("checkoutData", checkoutData)

    if (deliverType === 'table' || deliverType === 'takeaway') {

      if (phoneNumber === null || phoneNumber.length < 12) {
        console.log("phone", phoneNumber)

        return (
          <div className="btn btn-success btn-block btn-lg"
            onClick={() => {
              alert(tr("Please enter a valid phone number"))
            }}

          >{tr("Confirm Order")} </div>
        )
      }
      checkoutData.deliveryData.phone = phoneNumber
    }

    console.log("thanks data", checkoutData)

    if (paymentMethod && methodData && paymentMethod !== 'Cash') {
      return (
        <>
          <div onClick={() => doCheckout(checkoutData)} className="btn btn-success btn-block btn-lg">{tr("Confirm Payment & Order")}
            <i className="icofont-long-arrow-right" /></div>
        </>
      )
    }

    return (
      <>
        <div onClick={() => doCheckout(checkoutData)} className="btn btn-success btn-block btn-lg">{tr("Confirm Order")}
          <i className="icofont-long-arrow-right" /></div>
      </>
    )
  }

  const setPaymentDetails = (method) => {
    let methodData

    // if the method is Transfer get the bank and account number
    if (method === 'Transfer') {
      let banc = locationConfigValue(business.Configs, menu.Location.id, "bancolombia", null)

      if (banc) {
        methodData = banc
        //setBankName('Bancolombia')
      } else {

        banc = locationConfigValue(business.Configs, menu.Location.id, "davivienda", null)
        if (banc) {
          methodData = banc
          //setBankName('Davivienda')
        }
      }

    } else {
      methodData = locationConfigValue(business.Configs, menu.Location.id, method.toLowerCase(), null)
      if (!methodData) {
        configValue(business.Configs, method.toLowerCase(), null)
      }
    }

    SetMethodData(methodData)
  }

  const tableContent = () => {
    console.log("table content with", name, phone, table)

    return (
      <div>
        <form>
          <div className="form-row">

            <div className="form-group col-md-12">
              <label>{tr("Name")}</label>
              <span style={{ color: 'red' }}>*</span>
              <input className="form-control" type="text" placeholder={tr("Your name")}
                defaultValue={name}
                onChange={(event) => {
                  // console.log("phone", event.target.value)
                  setName(event.target.value)
                }} />
            </div>

            <div className="form-group col-md-12">
              <label>{tr("Phone")}</label>
              <span style={{ color: 'red' }}>*</span>
              <input id="add-address-phone" type="tel"
                defaultValue={phone}
                onChange={(event) => {
                  // does not get called when using intlTelInput
                  console.log("phone", event)
                  setPhone(event)
                }}
                style={{ width: "100%" }}
              />
            </div>

            {fixedTable ?

              <div className="col-12" style={{
                fontSize: '1.5em'
              }}>
                {tr("Table")} {table}
              </div>
              : <div className="form-group col-md-12">
                <label>{tr("Table Number")}</label>
                <span style={{ color: 'red' }}>*</span>
                <input className="form-control" type="number"
                  defaultValue={table}
                  onChange={(event) => {
                    console.log("table", event.target.value)
                    try {
                      let num = parseInt(event.target.value)
                      setTable(num)
                    } catch (ex) {
                      console.log(ex)
                    }
                  }} />
              </div>
            }

          </div>
        </form>

        <div className="pt-2"></div>

        <PaymentTypeChooser
          detailColour={'#F1AD3E'}
          methods={paymentMethods}
          paymentMethod={paymentMethod}
          methodData={methodData}
          bankName={bankName}
          paymentMethodSelected={(method) => {
            //console.log("payment method", tr(method))
            // set the payment details for the method
            if (method !== 'Cash') {
              setPaymentDetails(method)
            }
            setPaymentMethod(tr(method))
          }}

        />
      </div>
    )
  }

  const takeawayContent = () => {

    console.log("takeaway content with", name, phone, email)

    return (
      <div>
        <form>
          <div className="form-row">

            <div className="form-group col-md-12">
              <label>{tr("Name")}</label>
              <span style={{ color: 'red' }}>*</span>
              <input className="form-control" type="text" placeholder={tr("Your name")}
                defaultValue={name}
                onChange={(event) => {
                  // console.log("phone", event.target.value)
                  setName(event.target.value)
                }} />
            </div>

            <div className="form-group col-md-12">
              <label>{tr("Phone")}</label>
              <span style={{ color: 'red' }}>*</span>
              <input id="add-address-phone" type="tel"
                defaultValue={phone}
                onChange={(event) => {
                  // does not get called when using intlTelInput
                  console.log("phone", event)
                  setPhone(event)
                }}
                style={{ width: "100%" }}
              />
            </div>

            <div className="form-group col-md-12">
              <label>{tr("Email")}</label>
              <input className="form-control" type="text" placeholder={tr("Email for confirmation and receipt")}
                defaultValue={email}
                onChange={(event) => {
                  // console.log("phone", event.target.value)
                  setEmail(event.target.value)
                }} />
            </div>


          </div>
        </form>

        <div className="pt-2"></div>

        <PaymentTypeChooser
          detailColour={'#F1AD3E'}
          methods={paymentMethods}
          paymentMethod={paymentMethod}
          methodData={methodData}
          bankName={bankName}
          paymentMethodSelected={(method) => {
            //console.log("payment method", tr(method))
            if (method !== 'Cash') {
              setPaymentDetails(method)
            }
            //for more than one payment
            setPaymentMethod(tr(method))
          }}

        />
      </div>
    )
  }

  const calculateDistance = (bizlatLng, position, callback) => {

    let sll = null;

    try {
      sll = LatLon.fromString(bizlatLng)
    } catch (ex) {
      addDeliveryMessage("Error parsing business latlng", ex)
      return 0
    }
    let dll = null;

    try {
      dll = LatLon.fromObject(position)
    } catch (ex) {
      addDeliveryMessage("Error parsing delivery latlng", ex)
      return 0
    }


    let location = menu.Location

    //console.log("crow flies distance", Math.round(sll.distanceTo(dll)), location.flags)

    // try the maps API
    postToMapsApi({
      s: bizlatLng,
      e: `${position.latitude},${position.longitude}`,
    }, (data) => {
      console.log("route data", data)
      if (data && data.paths && data.paths.length > 0) {
        console.log("route distance", data.paths[0].distance)
        addDeliveryMessage("Distance calculated by route " + Math.round(data.paths[0].distance))
        callback(Math.round(data.paths[0].distance))
      } else {
        addDeliveryMessage("Error getting distance from route - no data")
        addDeliveryMessage("Using crow flies distance")
        callback(Math.round(sll.distanceTo(dll)))
      }
    }, (error) => {
      console.log("Error getting distance", error)
      addDeliveryMessage("Error getting distance from route")
      addDeliveryMessage("Using crow flies distance")
      callback(Math.round(sll.distanceTo(dll)))
    })
  }

  // const _alsoLike = () => {
  //   return (
  //     <div className="bg-white rounded shadow-sm p-4 mb-4">
  //       <h6 className="mb-3">{tr('You may also like')}</h6>
  //       {/* <ItemsCarousel /> */}
  //     </div>
  //   )
  // }

  const addDeliveryMessage = (message) => {
    //console.log("add delivery message", message)
    setDeliveryMessage(message)

    let msgs = calculationMessages
    msgs.push(message)

    setCalculationMessages(msgs)
  }

  const getDistanceCost = (menu, address, daid) => {
    addDeliveryMessage(tr("Calculating distance for delivery cost"))

    calculateDistance(menu.Location.latlng, address.position, (distance) => {

      if (distance > 0) {
        addDeliveryMessage(tr("Calculated distance") + " " + round(distance / 1000, 2) + "km")

        // get the delivery cost from the API
        let url = `/api/v1/delivery/estimated_cost/${daid}/${distance}`
        getFromApi(url, {}, (result) => {
          //console.log("estimated_cost", result.result)
          if (result.result > 0) {
            setChargeRange(result.result)
            setDistanceCost(result.result)
            addDeliveryMessage(tr("Delivery Fee") + " " + result.result + " for " + round(distance / 1000, 2) + "km")
          }

        }, (error) => {
          console.log("Error getting estimated delivery cost", error.responseJSON)
          addDeliveryMessage(tr("Error calculating distance cost"))
        })
      } else {
        addDeliveryMessage(tr("Calculated distance") + " " + distance + "km")
      }
    })
  }

  const getBarrioCost = (menu, address, daid) => {

    let barrio = address.barrio.replace("Barrio ", "")

    let url = `/api/v1/delivery/barrio_cost/${menu.Location.id}/${daid}/${barrio}`
    getFromApi(url, {}, (result) => {
      //console.log("barrio cost", result.result)
      if (result.result > 0) {
        setBarrioCost(result.result)
        addDeliveryMessage(tr("Deliver to") + " " + barrio + " Barrio")
      } else if (address.position) {
        // fallback to distance calculation

        getDistanceCost(menu, address, daid)
      }

    }, (error) => {
      console.log("Error getting barrio delivery cost", error.responseJSON)
      addDeliveryMessage(tr("Error getting barrio delivery cost"))
    })
  }

  let deliveryAgentLocationId = 0

  // an address has been selected, determine the delivery cost
  const onAddressSelected = (address) => {
    let noDeliveryCosts = menu.Location.flags && menu.Location.flags.includes("noDeliveryCharge")

    if (deliveryAgentLocationId > 0 && !noDeliveryCosts) {
      // the business configs have a delivery agent id

      //console.log("delivery agent id", daid)
      if (address.barrio && menu.Location.flags && menu.Location.flags.includes("barrioPricing")) {
        //console.log("get barrio cost", address.barrio)
        getBarrioCost(menu, address, deliveryAgentLocationId)
      } else if (address.position) {
        addDeliveryMessage(tr("No barrio pricing for this location"))

        // otherwise calculate the delivery cost for the distance for the business
        //console.log("get distance cost", address.position)
        getDistanceCost(menu, address, deliveryAgentLocationId)
      }
    }
    // else {
    //   addDeliveryMessage(tr("No delivery agent for this location"))
    // }

  }

  /*
  temp button to clear all barrios
  <div className="btn btn-sm btn-success mr-2" href="#" onClick={() => {
                for (let i = 0; i < addresses.length; i++) {
                  addresses[i].barrio = null
                }
                localStorage.setItem('addressList', JSON.stringify(addresses))
                    setAddresses(addresses.filter((a) => true));
              }}> Do not click me </div>
              */

  const deliveryContent = () => {

    deliveryAgentLocationId = locationConfigNumber(business.Configs, menu.Location.id, "deliveryServiceAgentId", 0)

    return (
      <div className="offer-dedicated-body-left">

        <div className="pt-2"></div>
        <div className="bg-white rounded shadow-sm p-4 mb-4">

          {addresses.length > 1 &&
            <div>
              <h4 className="mb-1">{tr("Choose a delivery address")}</h4>
              <h6 className="mb-3 text-black-50">{tr("Multiple addresses in this location")}</h6>

            </div>
          }

          <div className="row" >
            {addresses.map((address, idx) =>
              <div className="col-md-6" key={'address_' + idx}>
                <ChooseAddressCard
                  boxclassName="border border-success"
                  title={address.title}
                  icoIcon={iconForTitle(address.title)}
                  iconclassName='icofont-3x'
                  location={menu.Location}
                  address={address}
                  barrios={barrios}
                  agentId={deliveryAgentLocationId}
                  onBarrioChange={(barrio) => {
                    address.barrio = barrio

                    localStorage.setItem('addressList', JSON.stringify(addresses))
                    setAddresses(addresses.filter((a) => true));
                  }}
                  onDeliverHereClick={() => {
                    // check it has a position
                    setDeliveryAddress(address)

                    //console.log("set delivery address", address)

                    onAddressSelected(address)
                  }}
                  boxClass={deliveryAddress && address.address === deliveryAddress.address ? 'selected' : ''}
                  onDelete={() => {
                    // delete this address
                    let list = addresses.filter((addr) => addr.id !== address.id)
                    setAddresses(list)

                    localStorage.setItem('addressList', JSON.stringify(list))
                  }}
                />
              </div>

            )}

            <div className="col-md-6">
              <ChooseAddressCard
                title={newAddress.title}
                icoIcon="search-property"
                iconclassName='icofont-3x'
                type="newAddress"
                address={newAddress}
                location={menu.Location}
                barrios={barrios}
                onAddNewClick={() => {

                  navigator.geolocation.getCurrentPosition((position) => {
                    let result = { latitude: position.coords.latitude, longitude: position.coords.longitude }
                    setPosition(result)
                  }, () => {

                  })
                  console.log("add new address setShowAddressModal(true)")
                  // setShowAddressModal(true)
                  // addAddressModal()
                  showModal(newAddress.title,
                    <AddAddressForm
                      city={bestStringValue(selectedCity, menu.Location.city)}
                      province={selectedProvince}
                      country={menu.Location.country}
                      location={menu.Location}
                      barrios={barrios}

                      onHide={() => setShowCustomModal(false)}
                      onSubmit={(addr) => {

                        addr.id = uuidv4()

                        // save to the list of addresses in local storage and set as the delivery address
                        addresses.push(addr)

                        console.log("save address list", addresses)

                        localStorage.setItem('addressList', JSON.stringify(addresses))
                        setAddresses(addresses.filter((a) => true));

                        setShowCustomModal(false)

                        const $ = window.jQuery;

                        let key = "AIzaSyCUX9AYx-TJRgujhMclBdzrtXsIZLdCkFs"

                        key = "AIzaSyDs0smRFn4gbCSsJxpJH-Sopf_t149tFlQ"
                        let address = encodeURIComponent(`${addr.address},${addr.city},${addr.province}, Colombia`)
                        let uri = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${key}`

                        // use google geocoding API to convert the address to a geolocation
                        const options = {
                          url: uri,
                          method: 'GET',
                        }

                        // submit to the URI denoted by path
                        $.ajax(options)
                          .then((data) => {
                            //console.log('success converting address to gelocation via google API', data)

                            let result = data.results[0]

                            let geom = result.geometry.location
                            let position = { latitude: geom.lat, longitude: geom.lng }

                            addr.position = position

                            if (!addr.barrio || addr.barrio == "") {
                              // get the barrio
                              for (let i = 0; i < result.address_components.length; i++) {
                                let comp = result.address_components[i]
                                if (comp.long_name && comp.long_name.startsWith("Barrio")) {
                                  addr.barrio = comp.long_name.replace("Barrio ", "")
                                  break
                                }
                              }
                            }

                            //console.log("save address list", addresses)

                            localStorage.setItem('addressList', JSON.stringify(addresses))
                            setAddresses(addresses.filter((a) => true));
                            setDeliveryAddress(addr)
                            setShowAddressModal(false)
                            setPosition(position)

                            onAddressSelected(addr)

                          })
                          .catch((data) => {
                            console.log('error', data)
                            alert("Error al obtener la ubicación geográfica de la dirección. Esto significa que los costos de envío pueden no ser precisos y que podría pagar más de lo que debería. Considere verificar la dirección para verificar su exactitud.")
                            addr.position = position

                            localStorage.setItem('addressList', JSON.stringify(addresses))
                            setAddresses(addresses.filter((a) => true));
                            setDeliveryAddress(addr)
                            setShowAddressModal(false)

                            onAddressSelected(addr)
                          });


                      }} />,
                    undefined, // set onConfirm to undefined so no button is shown
                    undefined
                  )


                }
                }
              />
            </div>
          </div >


        </div>

        <div className="pt-2"></div>

        <PaymentTypeChooser
          detailColour={'#F1AD3E'}
          methods={paymentMethods}
          paymentMethod={paymentMethod}
          methodData={methodData}
          isDelivery={true}
          bankName={bankName}
          paymentMethodSelected={(method) => {
            //console.log("payment method", tr(method))
            if (method !== 'Cash') {
              setPaymentDetails(method)
            }
            //for more than one payment
            setPaymentMethod(tr(method))
          }}

        />

      </div>
    )
  }

  const validDOB = (dob) => {
    if (dob === null) return false;
    if (dob.length < 10) return false;

    // parse the date
    try {
      let d = Date.parse(dob)

      return true
    } catch (ex) {

    }
    return false
  }

  const alcoholContent = () => {
    return (
      <div className="offer-dedicated-body-left">

        <div className="pt-2"></div>
        <div className="bg-white rounded shadow-sm p-4 mb-4">
          <form>
            <div className="form-row">

              <div className="row" >

                <div className="form-group col-md-12">
                  <input
                    type="checkbox"
                    id="custom-checkbox"
                    label=" Declaro que soy comprador mayor de edad y
                      cumplo con los requisitos de la Ley 30 de 1986."

                    onChange={(e) => {
                      console.log("on change", e.target.checked)
                      setAgeConfirmed(e.target.checked)
                    }}
                  />
                </div>

                <div className="form-group col-md-12">
                  <label> Fecha de nacimiento (YYYY/MM/DD)
                  </label>
                  <div type="text" placeholder="Fecha de nacimiento (YYYY/MM/DD)"
                    className={validDOB(dateOfBirth) ? "form-group" : "form-group invalid-input"}
                    onChange={(e) => {
                      console.log("on change", e.target.value)
                      if (validDOB(e.target.value)) {
                        setDateOfBirth(e.target.value)
                      }
                    }}

                  />
                </div>
              </div >
            </div>
          </form>

        </div>

        <div className="pt-2"></div>

      </div>
    )
  }

  const getContent = () => {
    if (hasAlcohol() === true && (dateOfBirth === null || ageConfirmed === false)) {
      return alcoholContent()
    }
    // if (deliverType === "position") return positionContent()
    // else

    if (deliverType === "delivery") return deliveryContent()
    else if (deliverType === "takeaway") return takeawayContent()
    else if (deliverType === "table") return tableContent()

    //console.log("get delivery type", menu.tables > 0 && menu.orders == true )
    return (
      <div className="offer-dedicated-body-left">

        <div className="pt-2">
        </div>
        <div className="bg-white rounded shadow-sm p-4 mb-4">

          <DeliverTypeSelector menu={menu} business={business} location={menu.Location} order={{
            items: cartItems
          }}
            onSelected={(type) => {
              setDeliverType(type)

              let location = menu.Location

              if (type == "delivery") {
                // get the barrios
                if (location.city && location.city !== "" && barrios.length === 0 && location.flags && location.flags.includes("barrioPricing") && deliveryAgentId > 0) {
                  //console.log("Getting barrios for delivery agent", deliveryAgentId, location.city, location.flags)
                  // get the barrios for this city/province/country  barrios_for_agent

                  let url = `/api/v1/location/barrios_for_agent/${deliveryAgentId}/${location.city}/${location.province}/${location.country || 'Colombia'}`

                  getFromApi(url, {}, (data) => {
                    //console.log("Got barrios", data.result)
                    if (data.result && data.result.length > 0) setBarrios(data.result)
                  }, (err) => {
                    console.log("Error getting barrios", err)
                  })
                }
              } else {
                console.log("NOT Getting barrios for city", location.city, barrios.length, location.flags)
              }

              /*
                            if (type == "delivery") {

                              if (addresses.length == 0) {
                                setDeliverType("position")
                              } else if (addresses.length == 1) {
                                let address = addresses[0]

                                if (!address.position || !address.position.latitude) {
                                  console.log("getting position for primary address", address.address)
                                  setDeliverType("position")
                                } else {
                                  //console.log("primary address has position", address.position)
                                  setDeliverType(type)
                                }
                              } else {
                                setDeliverType(type)
                              }
                            }
               */
            }}
            deliveryChargeRange={deliveryChargeRange}
            hasTableDelivery={menu.tables > 0 && menu.orders === true}

          />
        </div></div>
    )
  }

  const _getTotalCostIncPacking = () => {
    if (!deliverType) {
      return totalItemsCost(cartItems)
    }
    if (deliverType !== "table") {
      return totalItemsCost(cartItems) + packingCost
    }
    return totalItemsCost(cartItems)
  }

  const totalWithDiscountElement = () => {
    let newCost = applyDiscount(totalItemsCost(cartItems), menu)

    //console.log("totalWithDiscountElement", totalItemsCost(cartItems), packingCost, totalWithDelivery, newCost, barrioCost, distanceCost)

    if (deliverType && deliverType !== "table") {

      let noDeliveryCosts = menu.Location.flags && menu.Location.flags.includes("noDeliveryCharge")

      // if the location has no delivery charge then don't add the delivery cost
      if (totalWithDelivery == true && !noDeliveryCosts) {
        return <h6 className="font-weight-bold mb-0 text-black totalWithDiscountElement">
          {tr("TO PAY")} <span className="float-right discounted-cost">{formatPrice(newCost + packingCost + (barrioCost || distanceCost || 0))}</span></h6>
      } else {
        return <h6 className="font-weight-bold mb-0 text-black totalWithDiscountElement">
          {tr("TO PAY")} <span className="float-right discounted-cost">{formatPrice(newCost + packingCost)}</span></h6>
      }
    }

    return <h6 className="font-weight-bold mb-0 text-black totalWithDiscountElement">
      {tr("TO PAY")} <span className="float-right discounted-cost">{formatPrice(newCost)}</span></h6>
  }

  let newAddress = {
    title: tr('New Address'),
    name: '',
    phone: ''
  }

  const deliveryCostElement = () => {
    if (deliverType !== "delivery" || totalWithDelivery == true) return <></>
    if (menu.Location.flags && menu.Location.flags.includes("noDeliveryCharge")) {
      return <></>
      // return <p className="mb-1">{tr("Free Delivery")}
      //   <span className="float-right text-dark">0</span>
      // </p>
    }
    if (barrioCost && barrioCost > 0) {
      return <span className="float-right text-dark"> + {formatPrice(barrioCost)}</span>
    }

    if (distanceCost && distanceCost > 0) {
      return <span className="float-right text-dark"> + {formatPrice(distanceCost)}</span>
    }

    if (deliveryChargeRange) {
      return <span className="float-right text-dark"> + {deliveryChargeRange}</span>
    }

    return <></>
  }

  const deliveryMessageElement = () => {
    const $ = window.jQuery;

    if (calculationMessages.length == 0) return <></>

    //console.log("deliveryMessageElement", deliveryMessage, calculationMessages)

    return <div>
      <p className="mb-1">{deliveryMessage}

        <span className="text-info ml-1" onClick={() => {
          let el = $("#distanceCalculationMessages")
          el.toggle()

        }}>
          <i className="icofont-info-circle" title={calculationMessages.join(",\n")} />
        </span>

      </p>
      <div id="distanceCalculationMessages" style={{ display: 'none' }}>
        {calculationMessages.map((msg, idx) => {
          return <p key={"msg_" + idx} className="mb-1">{msg}</p>
        }
        )}
      </div>
    </div>
  }

  const estimatedOrCalculatedDeliveryCost = () => {
    if (deliverType !== "delivery") return <></>

    // if the locaiton.flags have 'noDeliveryCharge' then no delivery charge
    if (menu.Location.flags && menu.Location.flags.includes("noDeliveryCharge")) {
      return <></>
      // return <p className="mb-1">{tr("Free Delivery")}
      //   <span className="float-right text-dark">0</span>
      // </p>
    }

    if (barrioCost && barrioCost > 0) {
      return <p className="mb-1 estimatedOrCalculatedDeliveryCost barrioCost">{tr("Calculated Delivery Fee")}
        <span className="float-right text-dark">{formatPrice(barrioCost)}</span>
      </p>
    }

    if (distanceCost && distanceCost > 0) {
      return <p className="mb-1 estimatedOrCalculatedDeliveryCost distanceCost">{tr("Estimated Delivery Fee")}
        <span className="text-info ml-1">
          <i className="icofont-info-circle" title={tr("Actual cost varies")} />
        </span>
        <span className="float-right text-dark">{formatPrice(distanceCost)}</span>
      </p>
    }

    if (deliveryChargeRange) {
      return <p className="mb-1 estimatedOrCalculatedDeliveryCost deliveryChargeRange">{tr("Estimated Delivery Fee")}
        <span className="text-info ml-1">
          <i className="icofont-info-circle" title={tr("Actual cost varies")} />
        </span>
        <span className="float-right text-dark">{deliveryChargeRange}</span>
      </p>
    }
  }

  //console.log("checkout with deliverType", deliverType, deliveryChargeRange, packingCost, cartItems)

  if (menu == null) return <></>

  let totalCost = _getTotalCostIncPacking()

  let city = bestStringValue(selectedCity, menu.Location.city)
  // console.log("city", city )
  // console.log("selectedCity", selectedCity)
  // console.log("selectedProvince", selectedProvince)
  //console.log("menu.Location", menu.Location)


  return (
    <section className="offer-dedicated-body mt-4 mb-4 pt-2 pb-2">

      <div className="container" >
        <div className="row" >
          <div className="col-md-8">
            <h3 > <i className="fa fa-chevron-left fa-2x mr-4"
              onClick={() => {
                setStage("detail")
              }}
            /> Seguir mirando</h3>

            {getContent()}
          </div>
          <div className="col-md-4">
            <div className="generator-bg rounded shadow-sm mb-4 p-4 osahan-cart-item">
              <div className="d-flex mb-4 osahan-cart-item-profile">
                <img fluid="true" className="mr-3 rounded-pill" alt="osahan" src={business.photo || "/img/2.jpg"} />
                <div className="d-flex flex-column">
                  <h6 className="mb-1 text-white">{business.name}
                  </h6>
                  <p className="mb-0 text-white"><i className="icofont-location-pin" /> {menu.Location.address}, {menu.Location.city}</p>
                </div>
              </div>
              <div className="bg-white rounded shadow-sm mb-2">
                {cartItems.map((item, index) => {
                  return <CheckoutItem
                    key={'cart_item_' + index}
                    itemName={item.name}
                    cartItem={item}
                    price={item.chosenPrice || item.price}
                    priceUnit="$"
                    id={item.id}
                    quantity={item.quantity}
                    show={true}
                    minValue={0}
                    maxValue={7}
                    setValue={(args) => {
                      //console.log("checkout item", args);
                      if (args.quantity === 0) {
                        removeItem(item, args);
                      } else {
                        setItemQuantity(item, args.quantity);
                      }
                    }}

                    formatPrice={formatPrice}
                  />
                }
                )}

              </div>

              { /* promo code */}

              <div className="mb-2 bg-white rounded p-2 clearfix">
                { /* item cost */}
                <p className="mb-1">{tr("Item Total")}
                  <span className="float-right text-dark">{formatPrice(totalItemsCost())}</span></p>


                {/*  <p className="mb-1">Restaurant Charges <span className="float-right text-dark">$62.8</span></p> */}

                {packingCost && deliverType && deliverType !== "table" &&
                  <p className="mb-1">{tr("Packaging charge")}
                    <span className="text-info ml-1">
                      <i className="icofont-info-circle" title={tr("Additional charges for packaging material")} />
                    </span>
                    <span className="float-right text-dark">{formatPrice(packingCost)}</span>


                  </p>
                }

                {estimatedOrCalculatedDeliveryCost()}
                {deliveryMessageElement()}

                <hr />

                {/* total discount*/}
                <p className="align-right mb-1 text-dark discountMessage">
                  <span >{discountMessage(menu)}</span>
                </p>

                {totalWithDiscountElement()}

                {deliveryCostElement()}

              </div>

              {confirmButton()}


            </div>

            <div className="pt-2"></div>
            { /*
            <div className="alert alert-success" role="alert">
              You have saved <strong>$1,884</strong> on the bill
            </div>
                  */}
            <div className="pt-2"></div>
          </div>
        </div >
      </div >

      {customModal()}

    </section>
  );
}


export default Checkout;

function PaymentTypeChooser(props) {

  const { methods, bankName, paymentMethod } = props

  const { tr /* , getTranslations, locale, translations, setLocale */ } = useTranslations();

  const $ = window.jQuery

  console.log("payment props", props)

  const _cashMethod = () => {
    return (
      <div className="col-12 col-md-6 ">
        <div className={`payment-option ${paymentMethod === 'Cash' || paymentMethod === 'Efectivo' ? 'selected' : ''}`}
          id="payment-option-cash"
          onClick={() => {
            //console.log("clicked")
            $(".payment-option").removeClass("selected")
            $("#payment-option-cash").addClass("selected")
            // setPaymentMethod("cash")
            props.paymentMethodSelected('Cash')
          }
          }>
          <img src="/images/cash.png" height={90} alt="Cash" />
        </div>
      </div>
    )
  }
  const _transferMethod = () => {
    return (
      <div className="col-12 col-md-6 ">
        <div className={`payment-option ${paymentMethod === 'Transfer' ? 'selected' : ''}`}

          id="payment-option-transfer"
          onClick={() => {
            $(".payment-option").removeClass("selected")
            $("#payment-option-transfer").addClass("selected")
            //setPaymentMethod("transfer")
            props.paymentMethodSelected('Transfer')
          }
          }>
          {bankName === 'Bancolombia' && <img src="/img/bank/bancolombia.png" height={90} alt={bankName} />}
          {bankName === 'Davivienda' && <img src="/img/bank/davivienda.png" height={90} alt={bankName} />}

        </div>
      </div>
    )
  }

  const _nequiMethod = () => {
    return (<div className="col-12 col-md-6 ">
      <div className={`payment-option ${paymentMethod === 'Nequi' ? 'selected' : ''}`}

        id="payment-option-nequi"
        onClick={() => {
          $(".payment-option").removeClass("selected")
          $("#payment-option-nequi").addClass("selected")
          //setPaymentMethod("nequi")
          props.paymentMethodSelected('Nequi')
        }
        }>
        <img src="/images/nequi.png" height={90} alt="Nequi" />
      </div>
    </div>)
  }

  const _daviplataMethod = () => {
    return (
      <div className="col-12 col-md-6 ">
        <div className={`payment-option ${paymentMethod === 'Daviplata' ? 'selected' : ''}`}

          id="payment-option-daviplata"
          onClick={() => {
            $(".payment-option").removeClass("selected")
            $("#payment-option-daviplata").addClass("selected")
            //setPaymentMethod("daviplata")
            props.paymentMethodSelected('Daviplata')
          }
          }>
          <img src="/images/daviplata.png" height={90} alt="Daviplata" />
        </div>
      </div>
    )
  }

  const _cardMethod = () => {
    return (
      <div className="col-12 col-md-6 ">
        <div className={`payment-option ${paymentMethod === 'Card' ? 'selected' : ''}`}

          id="payment-option-card"
          onClick={() => {
            $(".payment-option").removeClass("selected")
            $("#payment-option-card").addClass("selected")

            props.paymentMethodSelected('Card')
          }
          }>
          <img src="/images/cards.png" height={90} alt="Card" />
        </div>
      </div>
    )
  }

  const _allMethods = () => {

    if (props.methods.length === 0) return (
      <div className='row get-payment-method product-delivery'>
        {_cashMethod()}
      </div>
    )
    let mt = "cash"
    try {
      mt = props.methods.join(",").toLowerCase()
    } catch (ex) {
      console.log("error", ex)
    }
    return (
      <div className='row get-payment-method product-delivery'>

        {mt.includes('cash') && _cashMethod()}

        {mt.includes('transfer') && bankName && _transferMethod()}

        {mt.includes('nequi') && _nequiMethod()}

        {mt.includes('daviplata') && _daviplataMethod()}

        {mt.includes('card') && _cardMethod()}

      </div>
    )
  }

  if (paymentMethod) {
    return (
      <div className="bg-white rounded shadow-sm p-4 checkout-payment">

        {_allMethods()}

      </div>
    )
  }

  return (
    <div className="bg-white rounded shadow-sm p-4 checkout-payment">
      <h4 className="mb-1">{tr("Choose payment method")}</h4>

      {_allMethods()}

    </div>
  )
}

/*

function promoCode(props) {
  return (
    <div className="mb-2 bg-white rounded p-2 clearfix">
                <div className="input-group"  className="input-group-sm mb-2">
                  <input className="form-control"type="text" placeholder="Enter promo code" />
                  <div className="input-group" .Append>
                    <button className="btn btn-primary"  type="button" id="button-addon2"><i className="icofont-sale-discount" /> APPLY</button>
                  </div .Append>
                </div >
                <div className="input-group"  className="mb-0">
                  <div className="input-group" .Prepend>
                    <div className="input-group" .Text><i className="icofont-comment" /></div .Text>
                  </div .Prepend>
                  <input className="form-control" as="textarea" placeholder="Any suggestions? We will pass it on..." aria-label="With textarea" />
                </div >
              </div>
  )
}
function complexPaymentTypes(props) {

  return (

    <div className="bg-white rounded shadow-sm p-4 osahan-payment">
    <h4 className="mb-1">Choose payment method</h4>
    <h6 className="mb-3 text-black-50">Credit/Debit Cards</h6>
    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
      <div className="row" >
        <div className="col col-sm-4" className="pr-0">
          <Nav variant="pills" className="flex-column">
            <Nav.Link eventKey="first"><i className="icofont-credit-card" /> Credit/Debit Cards</Nav.Link>
            <Nav.Link eventKey="second"><i className="icofont-id-card" /> Food Cards</Nav.Link>
            <Nav.Link eventKey="third"><i className="icofont-card" /> Credit</Nav.Link>
            <Nav.Link eventKey="fourth"><i className="icofont-bank-alt" /> Netbanking</Nav.Link>
            <Nav.Link eventKey="fifth"><i className="icofont-money" /> Pay on Delivery</Nav.Link>
          </Nav>
        </div>
        <div className="col col-sm-8" className="pl-0">
          <Tab.Content className='h-100'>
            <Tab.Pane eventKey="first">
              <h6 className="mb-3 mt-0 mb-3">Add new card</h6>
              <p>WE ACCEPT <span className="osahan-card">
                <i className="icofont-visa-alt" />
                <i className="icofont icofont-mastercard-alt" />
                <i className="icofont icofont-american-express-alt" />
                <i className="icofont icofont-payoneer-alt" />
                <i className="icofont icofont-apple-pay-alt" />
                <i className="icofont icofont-bank-transfer-alt" />
                <i className="icofont icofont-discover-alt" />
                <i className="icofont icofont-jcb-alt" />
              </span>
              </p>
              <form>
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <label>Card number</label>
                    <div className="input-group" >
                      <input className="form-control"type="number" placeholder="Card number" />
                      <div className="input-group" .Append>
                        <button type="button" className="btn btn-outline-secondary"  type="button" id="button-addon2"><i className="icofont-card" /></button>
                      </div .Append>
                    </div >
                  </div>
                  <div className="form-group col-md-8">
                    <label>Valid through(MM/YY)
                    </label>
                    <input className="form-control"type="number" placeholder="Enter Valid through(MM/YY)" />
                  </div>
                  <div className="form-group col-md-4">
                    <label>CVV
                    </label>
                    <input className="form-control"type="number" placeholder="Enter CVV Number" />
                  </div>
                  <div className="form-group col-md-12">
                    <label>Name on card
                    </label>
                    <input className="form-control"type="text" placeholder="Enter Card number" />
                  </div>
                  <div className="form-group col-md-12">
                    <input
                      type="checkbox"
                      id="custom-checkbox1"
                      label="Securely save this card for a faster checkout next time."
                    />
                  </div>
                  <div className="form-group col-md-12 mb-0">
                    <a href="/thanks" className="btn btn-success btn-block btn-lg">PAY $1329
                      <i className="icofont-long-arrow-right" />
                    </a>
                  </div>
                </div>
              </form>
            </Tab.Pane>
            <Tab.Pane eventKey="second">
              <h6 className="mb-3 mt-0 mb-3">Add new food card</h6>
              <p>WE ACCEPT  <span className="osahan-card">
                <i className="icofont-sage-alt"></i> <i className="icofont-stripe-alt"></i> <i className="icofont-google-wallet-alt-1"></i>
              </span>
              </p>
              <form>
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <label>Card number</label>
                    <div className="input-group" >
                      <input className="form-control"type="number" placeholder="Card number" />
                      <div className="input-group" .Append>
                        <button type="button" className="btn btn-outline-secondary"  type="button" id="button-addon2"><i className="icofont-card" /></button>
                      </div .Append>
                    </div >
                  </div>
                  <div className="form-group col-md-8">
                    <label>Valid through(MM/YY)
                    </label>
                    <input className="form-control"type="number" placeholder="Enter Valid through(MM/YY)" />
                  </div>
                  <div className="form-group col-md-4">
                    <label>CVV
                    </label>
                    <input className="form-control"type="number" placeholder="Enter CVV Number" />
                  </div>
                  <div className="form-group col-md-12">
                    <label>Name on card
                    </label>
                    <input className="form-control"type="text" placeholder="Enter Card number" />
                  </div>
                  <div className="form-group col-md-12">
                    <input
                      type="checkbox"
                      id="custom-checkbox"
                      label="Securely save this card for a faster checkout next time."
                    />
                  </div>
                  <div className="form-group col-md-12 mb-0">
                    <a href="/thanks" className="btn btn-success btn-block btn-lg">PAY $1329
                      <i className="icofont-long-arrow-right" />
                    </a>
                  </div>
                </div>
              </form>
            </Tab.Pane>
            <Tab.Pane eventKey="third">
              <div className="border shadow-sm-sm p-4 d-flex align-items-center bg-white mb-3">
                <i className="icofont-apple-pay-alt mr-3 icofont-3x" />
                <div className="d-flex flex-column">
                  <h5 className="card-title">Apple Pay</h5>
                  <p className="card-text">Apple Pay lets you order now & pay later at no extra cost.</p>
                  <a href="#" className="card-link font-weight-bold">LINK ACCOUNT <i className="icofont-link-alt" /></a>
                </div>
              </div>
              <div className="border shadow-sm-sm p-4 d-flex bg-white align-items-center mb-3">
                <i className="icofont-paypal-alt mr-3 icofont-3x" />
                <div className="d-flex flex-column">
                  <h5 className="card-title">Paypal</h5>
                  <p className="card-text">Paypal lets you order now & pay later at no extra cost.</p>
                  <a href="#" className="card-link font-weight-bold">LINK ACCOUNT <i className="icofont-link-alt" /></a>
                </div>
              </div>
              <div className="border shadow-sm-sm p-4 d-flex bg-white align-items-center">
                <i className="icofont-diners-club mr-3 icofont-3x" />
                <div className="d-flex flex-column">
                  <h5 className="card-title">Diners Club</h5>
                  <p className="card-text">Diners Club lets you order now & pay later at no extra cost.</p>
                  <a href="#" className="card-link font-weight-bold">LINK ACCOUNT <i className="icofont-link-alt" /></a>
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="fourth">
              <h6 className="mb-3 mt-0 mb-3">Netbanking</h6>
              <form>
                <ButtonToolbar>
                  <ToggleButtonGroup className="d-flex w-100" type="checkbox" name="options" defaultValue={1}>
                    <ToggleButton variant='info' value={1}>
                      HDFC <i className="icofont-check-circled" />
                    </ToggleButton>
                    <ToggleButton variant='info' value={2}>
                      ICICI <i className="icofont-check-circled" />
                    </ToggleButton>
                    <ToggleButton variant='info' value={3}>
                      AXIS <i className="icofont-check-circled" />
                    </ToggleButton>
                  </ToggleButtonGroup>
                </ButtonToolbar>
                <hr />
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <label>Select Bank
                    </label>
                    <br />
                    <input className="form-control"as="select" className="custom-select">
                      <option>Bank</option>
                      <option>One</option>
                      <option>Two</option>
                      <option>Three</option>
                    </Form.Control>
                  </div>
                  <div className="form-group col-md-12 mb-0">
                    <a href="/thanks" className="btn btn-success btn-block btn-lg">PAY $1329
                      <i className="icofont-long-arrow-right" /></a>
                  </div>
                </div>
              </form>
            </Tab.Pane>
            <Tab.Pane eventKey="fifth">
              <h6 className="mb-3 mt-0 mb-3">Cash</h6>
              <p>Please keep exact change handy to help us serve you better</p>
              <hr />
              <form>
                <a href="/thanks" className="btn btn-success btn-block btn-lg">PAY $1329
                  <i className="icofont-long-arrow-right" /></a>
              </form>
            </Tab.Pane>
          </Tab.Content>
        </div>
      </div >
    </Tab.Container>
  </div>

  )
} */